//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.RedistribuceKPrevzetiListPage.ts     </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{

    @Decorators.gcontent
    export class RedistribuceKPrevzetiListPage extends GContentBase<PodDokSpisListBasePage>
    {
        // filtr seznamu
        model: Wfl.Interface.GRedistribuceKPrevzetiFilterDto;

        onContentReady() {
            PodDokSpisListBasePage.InitList(this);
            this.FrmFiltr = "red_prev";
            this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPrevzit(this, true));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionOdmitnoutPrevzeti(this, true));
            this.subTaskActions.push(this.CreateActionSubtask(Wfl.Interface.TypSeznamuDokSpis.kPrevzetiVsechno));
            this.subTaskActions.push(this.CreateActionSubtask(Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            this.SetSubtask(Wfl.Interface.TypSeznamuDokSpis.kPrevzetiVsechno);
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků

            filterForm.addSection("")
            switch (this.TypSeznamu)
            {
                case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiVsechno:
                    filterForm.addSection("");
                    filterForm.addRow()
                        .addField("gcheck", { name: "TakeNaCeste", label: "jres:23900138" })//RC 23900138 : I dokumenty/spisy na cestě
                        .addField("gcheck", { name: "SmerovaneOdCizichStredisek", label: "jres:23900139" }); //RC 23900139 : Směřované od cizích středisek
                    //filterForm.addRow().addField("gcheck", { name: "PovolitPrevzetiIAnalogovych", label: "jres:23900140" }); //RC 23900140 : Povolit převzetí i analogových (fyzických) dokumentů (a automaticky je označovat)
                    //filterForm.addRow().addField("gcheck", { name: "AutomatickyOznacitDigitalni", label: "jres:23900141" }); //RC 23900141 : Při zobrazení přehledu automaticky označit digitální dokumenty a spisy bez analogové formy
                    break;
                case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem:
                    filterForm.addSection("");
                    filterForm.addRow({ label: "" }).addField("gradio", {
                        name: "TypSubjektu", itemClass: "",
                        initialValue: this.model.TypSubjektu,
                        radios: [
                            { value: Gin.Interface.IxsType.IxsSu, label: 'jres:23900144' }, //RC 23900144 : od uzlu
                            { value: Gin.Interface.IxsType.IxsFun, label: 'jres:23900145' }, //RC 23900145 : od osoby
                        ],
                        //change: function (event, input) {
                        //    if (!input.value)
                        //    {

                        //    }
                        //}
                    })
                    filterForm.addRow("jres:23900243") //RC 23900243 : Předávající
                    filterForm.addField("gselectbox",
                        Gordic.Gin.Fields.ginspodSSU(
                            {
                                name: "suField",
                                model: "model.Predavajici.ixs_su = ixs_su",
                                serverFilters: {
                                    aktivita: [100],
                                },
                            }, false))

                        .addField("gselectbox",
                            Gordic.Gin.Fields.ginsfunSSU(
                                {
                                    name: "funField",
                                    model: "model.Predavajici.ixs_fun = ixs_fun",
                                    serverFilters: {
                                        aktivita: [100],
                                        //DlePovolenychAgend: true,
                                        //VazbaNaSpisovyDenik: this.SslPripreomezPar == 1,
                                        ixs_su: new Gordic.Forms.Dependency("suField", "ixs_su")
                                    },
                                }, false, "suField"))

                    //filterForm.addPrefab(Gordic.Gin.Prefabs.GSuFunRef
                    //    {
                    //        name: "Predavajici",
                    //        model: "model.Predavajici.ixs_su=value.ixs_su;model.Predavajici.ixs_fun=value.ixs_fun",
                    //        serverFilters: {
                    //            aktivita: [100],
                    //        },
                    //        change: function (ev, data) {
                    //            //that.SuFunRefChange(data.value);
                    //        }
                    //    },
                    //    // 26.03.2020 - TFeik
                    //    // Doplněn příznak zda se funkce používá v redistribuci / předání.
                    //    undefined,
                    //    {
                    //        modPredani: true
                    //    }));
                    filterForm.addRow()
                        .addField("gcheck", { name: "SmerovatMeOsobe", label: "jres:23900142" })//RC 23900142 : Směřovat mé osobě
                        .addField("gcheck", { name: "PredatNaOsobu", label: "jres:23900143", change: (ev, obj) => { this.PredatNaOsobu = obj.value; } }); //RC 23900143 : Předat na osobu
                    break;
            }
            return [filterForm];
        }

        SetSubtask(typ: Wfl.Interface.TypSeznamuDokSpis) {
            this.TypSeznamu = typ;   
            this.CreateList();
            this.AutorizovatPrevzeti = typ == Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem;
            Gordic.Wfl.ListAC.DokSpisListBaseAC.EnabledAction(this);
        }

        CreateList()
        {
            if (this.filterForm) this.filterForm.remove();
            var that = this;
            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dspreo" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                });

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            that.SetActionVisible();
            var l_nacist = this.NacistSeznamPriOtevreni;
            if (!that.model.Predavajici.ixs_su) l_nacist = false;
            this.filterForm.gfilterpanel("applyFilter", this.model, !l_nacist)
        }

        CreateActionSubtask(typ: Wfl.Interface.TypSeznamuDokSpis): GAction
        {
            var l_caption = "";
            switch (typ)
            {
                case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiVsechno:
                    l_caption = "jres:23900136"; //RC 23900136 : Všechny
                    break;
                case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem:
                    l_caption = "jres:23900137"; //RC 23900137 : Příjem
                    break;                
            }

            var that = this;
            var action = new GAction({
                name: Gin.Globals.Enums.ActionsName.Subtask + typ,
                caption: l_caption,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.AlwaysEnabled,
                run: function (ev, ctx) {
                    that.SetSubtask(typ);
                }
            });
            return action;
        }

        LoadData(filtr?: Wfl.Interface.GRedistribuceKPrevzetiFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.model = $.extend({}, this.model, filtr);
            if (this.model)
            {
                switch (this.TypSeznamu)
                {
                    case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem:

                        if (!that.model.Predavajici.ixs_su)
                        {
                            Wfl.AC.WflBaseAC.ShowFlashWarning(this, "jres:23900247"); //RC 23900247 : Vyplňte předávající uzel.
                        }
                        else
                        {
                            this.call<Wfl.Interface.DokSpisListDto[]>("LoadDataPrijem", { model: this.model })
                                .done(function (data) {
                                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                                    Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                                    that.IxsSuOperation = that.model.Predavajici.ixs_su;
                                    that.IxsFunOperation = that.model.Predavajici.ixs_fun;
                                })
                                .always(function () { Gordic.Wfl.ListAC.DokSpisListBaseAC.AfterLoadData(that); });
                        }

                        break;
                    case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiVsechno:
                        this.call<Wfl.Interface.DokSpisListDto[]>("LoadDataVsechny", { model: this.model })
                            .done(function (data) {
                                var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                                Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                            })
                            .always(function () { Gordic.Wfl.ListAC.DokSpisListBaseAC.AfterLoadData(that); });
                        break;
                }
            }
        }

        ReloadData()
        {
            this.LoadData(this.model);
        }

        SetActionVisible()
        {
            let l_OdmitnoutPrevzetivisible = false;
            switch (this.TypSeznamu)
            {
                case Wfl.Interface.TypSeznamuDokSpis.kPrevzetiPrijem:
                    l_OdmitnoutPrevzetivisible = true;
                    break;
            }
            Wfl.ListAC.WflListBaseAC.SetActionVisible(this, Wfl.Globals.Enums.ActionsName.OdmitnoutPrevzeti, l_OdmitnoutPrevzetivisible)
        }
    }
};
